var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFullColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 69,
    viewBox: "0 0 267 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M31.261 18.3061L46.7634 43.525L62.394 68.744H31.261H0L15.6305 43.525L31.261 18.3061Z",
    fill: "#13487D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M54.9631 0L70.5936 34.436L86.2241 68.744H54.9631H23.702L39.3325 34.436L54.9631 0Z",
    fill: "#1C75BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M43.048 9.85715L58.6785 39.3006L74.309 68.744H43.048H11.9151L27.5456 39.3006L43.048 9.85715Z",
    fill: "#6DCFF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 9.85715H93.655V31.7477H95.4487V9.85715Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.745 21.5065C116.076 20.9944 117.998 18.9462 117.998 15.7458C117.998 12.1614 115.435 9.85715 111.207 9.85715H101.47V31.7477H103.264V21.6345H110.567L117.613 31.6197V31.7477H119.791L112.745 21.5065ZM103.264 11.5213H111.079C114.282 11.5213 116.076 13.0575 116.076 15.7458C116.076 18.4341 114.282 19.9703 111.079 19.9703H103.264V11.5213Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.116 9.4731C126.838 9.4731 122.226 14.3377 122.226 20.7384C122.226 27.1391 126.966 32.0037 133.116 32.0037C139.265 32.0037 144.006 27.1391 144.006 20.7384C144.006 14.3377 139.393 9.4731 133.116 9.4731ZM133.116 30.3395C127.991 30.3395 124.019 26.243 124.019 20.7384C124.019 15.3618 127.863 11.2653 133.116 11.2653C138.24 11.2653 142.084 15.3618 142.084 20.7384C142.212 26.243 138.369 30.3395 133.116 30.3395Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.889 28.4193L150.54 9.85715H149.002V31.7477H150.796V13.0575L165.145 31.6197V31.7477H166.683V9.85715H164.889V28.4193Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.392 57.6067L95.1924 46.8535H93.3988V68.616H95.1924V49.7978L102.751 59.655H102.88H103.905L111.464 49.7978V68.616H113.385V46.8535H111.592L103.392 57.6067Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.144 46.4694C122.866 46.4694 118.254 51.334 118.254 57.7347C118.254 64.1354 122.994 69 129.144 69C135.294 69 140.034 64.1354 140.034 57.7347C140.034 51.334 135.422 46.4694 129.144 46.4694ZM129.144 67.3358C124.019 67.3358 120.047 63.2393 120.047 57.7347C120.047 52.3581 123.891 48.2616 129.144 48.2616C134.269 48.2616 138.112 52.3581 138.112 57.7347C138.112 63.2393 134.269 67.3358 129.144 67.3358Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M160.405 59.2709C160.405 64.2635 157.843 67.2078 153.487 67.2078C149.131 67.2078 146.568 64.2635 146.568 59.2709V46.7254H144.774V59.2709C144.774 65.2876 148.106 69 153.615 69C158.996 69 162.455 65.2876 162.455 59.2709V46.7254H160.661V59.2709H160.405Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M183.595 65.4156L169.245 46.8535H167.708V68.616H169.501V50.0538L183.851 68.616H185.388V46.8535H183.595V65.4156Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.4 46.8535H189.104V48.5177H196.919V68.616H198.713V48.5177H206.4V46.8535Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M216.265 46.7254H214.599L204.734 68.4879L204.606 68.744H206.528L209.346 62.4712H221.262L224.08 68.744H226.002L216.265 46.7254ZM220.621 60.679H210.115L215.368 49.1577L220.621 60.679Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.639 46.8535H229.845V68.744H231.639V46.8535Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.547 65.4156L239.326 46.8535H237.661V68.616H239.583V50.0538L253.804 68.616H253.932H255.469V46.8535H253.547V65.4156Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 45.4453C260.722 45.4453 258.8 47.2375 258.8 49.5417C258.8 51.846 260.594 53.6382 262.9 53.6382C265.206 53.6382 267 51.846 267 49.5417C267 47.3655 265.206 45.4453 262.9 45.4453ZM262.9 52.9981C260.978 52.9981 259.441 51.462 259.441 49.5417C259.441 47.6215 260.978 46.0853 262.9 46.0853C264.822 46.0853 266.359 47.6215 266.359 49.5417C266.359 51.462 264.822 52.9981 262.9 52.9981Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.694 48.6456C264.694 47.8776 264.181 47.3655 263.285 47.3655H261.363V51.718H262.132V49.9258H263.156L264.438 51.718H265.334L263.925 49.7978C264.438 49.5417 264.694 49.1577 264.694 48.6456ZM262.132 48.0056H263.285C263.541 48.0056 263.925 48.1336 263.925 48.5176C263.925 48.9017 263.669 49.0297 263.285 49.0297H262.132V48.0056Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullColor);
export default __webpack_public_path__ + "static/media/LogoFullColor.bc8d0a3b0fbbaa8bc06ddad519d88b4b.svg";
export { ForwardRef as ReactComponent };